import React from 'react'
import { IconButton, Icon } from 'rsuite'

export default function ViewButton({
  onClick,
  children = 'แสดง',
  disabled,
  icon = 'eye',
  styleVal = { marginRight: '10px' },
  ...props
}) {
  return (
    <IconButton
      appearance="ghost"
      className="rs-btn-ghost-info"
      style={styleVal}
      onClick={onClick}
      icon={<Icon className="bt-gost-icon-radius-info" icon={icon} />}
      disabled={disabled}
      {...props}
    >
      {children}
    </IconButton>
  )
}
